export const capitalizeFirstLetter = (value: unknown): string => {
  if (typeof value !== "string") return ""
  const trimmed = value.trim()
  if (!trimmed) return ""
  return trimmed.charAt(0).toLocaleUpperCase() + trimmed.slice(1)
}
